/* eslint-disable */
import React,{useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../../component/Inc/Paging';
import Tab from '../../../component/Inc/Tab';
function MeetingReport() {
  const [modalOpen, setModalOpen] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title:"인사총무", cnt:"435", value:0},
    {title:"경영지원", cnt:"5", value:1},
    {title:"츨판사업", cnt:"5", value:2},
    {title:"사업운영", cnt:"5", value:3},
    {title:"입시전략", cnt:"5", value:4},
    {title:"관리부", cnt:"5", value:5},
    {title:"교무부", cnt:"5", value:5},
  ];
  return (
    <main className="com_container com_work_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu12_14'>회의록</h2>
          <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">회의록 등록</button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className='com_board_list__top'>
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="full" />
            </div>
            <div className='com_board_list__top'>
              <section className='com_board_search end'>
                <article className='search'>
                  <input type="search" placeholder='검색할 내용을 입력해 주세요.' className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className='com_board_list'>
              <colgroup>
                <col width="14%"/><col width="14%"/>
                <col /><col width="12%"/>
                <col width="13%"/><col width="13%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>등록일</th>
                  <th>등록 부서</th>
                  <th>제목</th>
                  <th>파일</th>
                  <th>등록자</th>
                  <th>조회</th>
                </tr>
              </thead>
              <tbody>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>2022.08.25 12:30</td>
                      <td>인사총무</td>
                      <td className='td_left'>인사팀 주간 업무보고 입니다.</td>
                      <td><button className="btn_link blue">다운로드</button></td>
                      <td>홍길동103</td>
                      <td>34</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count"><p>조회 <span className="cnt">321</span></p></div>
            </div>
            <div className="com_input_wrap">
              <div className="sec_input select_box">
                <select className="select">
                  <option value="카테고리선택">카테고리선택</option>
                  <option value="카테고리선택">카테고리선택</option>
                </select>
                <div className="com_btn_wrap">
                  <button className="btn_edit"></button>
                  <button className="btn_delete"></button>
                </div>
              </div>
              <div className="sec_input">
                <input type="text" className="input" placeholder='제목 입력' />
              </div>
              <div className="editor">
                내용입력(에디터)
              </div>
              <div className="search_wrap">
                <section className='com_board_search'>
                  <article className='search'>
                    <input type="search" placeholder='검색할 내용을 입력해 주세요.' className="input s" />
                    <button className="com_btn gray ws s icon_search"></button>
                  </article>
                </section>
                <div className="attend_list">
                  <p className="item">
                    <span className="txt">김참석12</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </p>
                  <p className="item">
                    <span className="txt">김참석12</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </p>
                  <p className="item">
                    <span className="txt">김참석12</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </p>
                  <p className="item">
                    <span className="txt">김참석12</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </p>
                  <p className="item">
                    <span className="txt">김참석12</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </p>
                  <p className="item">
                    <span className="txt">김참석12</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </p>
                  <p className="item">
                    <span className="txt">김참석12</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </p>
                  <p className="item">
                    <span className="txt">김참석12</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  </p>
                </div>
              </div>
              <div className="com_input_upload">
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button type="button" className="btn_down" onClick={() => {}}></button>
                </p>
              </div>
              <div className="com_input_upload">
                <p className="file">
                  <span className="txt">File nameFile nameFile name.pdf</span>
                  <button type="button" className="btn_down" onClick={() => {}}></button>
                </p>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default MeetingReport;
